module.exports = "a {\n  text-decoration: none; }\n\ndiv {\n  -webkit-text-size-adjust: none; }\n\n.anima-full-width-a {\n  width: 100%; }\n\n.anima-full-height-a {\n  height: 100%; }\n\ndiv {\n  -webkit-text-size-adjust: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main